var scroll = {
    $trigger : $(".js__scroll-position"),
    $target : $(".js__scroll-target,.js__scroll-title,.js__scroll-text,.js__scroll-object"),
    position: [],
    h: 0,
    scr : 0,

    init : function () {

        for (let i = 0; i < $(".js__scroll-title").length; i++){
            let en = new SplitText($(".js__scroll-title").eq(i).find(".c-font__en"), {type: "words,chars"});
            let jp = new SplitText($(".js__scroll-title").eq(i).find(".c-font__jp"), {type: "words,chars"});
        }

    },

    resize : function () {

        scroll.position = [];

        for (let i = 0; i < scroll.$trigger.length; i++) {
            scroll.position[i] = scroll.$trigger.eq(i).offset().top;
        }

    },

    motion : function(){

        for (let i = 0; i <  scroll.position.length; i++) {
            if( scroll.position[i] <= scroll.scr + (scroll.h * 0.75)) {
                scroll.$trigger.eq(i).find(scroll.$target).addClass("is-done");
            }
        }

    }
}

$(window).on("load resize",function () {
    if($(".js__scroll-position")[0]) scroll.init();
});
$(window).on("load resize",function () {
    if($(".js__scroll-position")[0]) scroll.resize();
});
$(window).on("load scroll",function () {
    scroll.h = $(window).height();
    scroll.scr = $(window).scrollTop();
    if($(".js__scroll-position")[0]) scroll.motion();
});
